import {
  METHOD_DELETE,
  METHOD_GET,
  METHOD_POST,
  METHOD_PUT,
} from "./constants";
import stringify from "../QueryString";

class HttpClient {
  constructor(private baseUrl = "", private headers?: Headers) {
    if (typeof fetch === "undefined") {
      throw new Error(
        "HttpClient requires a Fetch API implementation, but the current environment doesn't support it. You may need to load a polyfill such as https://github.com/github/fetch"
      );
    }
  }

  setHeaders(headers: Headers): void {
    this.headers = headers;
  }

  private buildRequest(input: string, options?: RequestInit): Request {
    return new Request(this.baseUrl + input, {
      headers: this.headers,
      ...options,
      mode: "cors",
    });
  }

  private fetch(
    input: string,
    requestInit?: RequestInit,
    options?: Object
  ): Promise<Response> {
    const request = this.buildRequest(input, requestInit);

    return fetch(request, options).then(async (response: Response) => {
      if (!response.ok) {
        throw response;
      }

      return response;
    });
  }

  get(
    input: string,
    parameters?: Record<string, unknown>,
    options?: Object
  ): Promise<Response> {
    if (parameters) {
      const queryParameters = stringify(parameters);

      return this.fetch(`${input}?${queryParameters}`, options);
    }

    return this.fetch(
      input,
      {
        method: METHOD_GET,
      },
      options
    );
  }

  post(
    url: string,
    parameters: unknown = null,
    options: Object = {}
  ): Promise<Response> {
    return this.fetch(url, {
      method: METHOD_POST,
      body: HttpClient.getBody(parameters),
      ...options,
    });
  }

  put(
    url: string,
    parameters: unknown = null,
    options: Object = {}
  ): Promise<Response> {
    return this.fetch(url, {
      method: METHOD_PUT,
      body: HttpClient.getBody(parameters),
      ...options,
    });
  }

  delete(url: string, parameters: unknown = null): Promise<Response> {
    return this.fetch(url, {
      method: METHOD_DELETE,
      body: HttpClient.getBody(parameters),
    });
  }

  private static getBody(parameters: unknown): FormData | string | null {
    if (!parameters) {
      return null;
    }

    if (parameters instanceof FormData) {
      return parameters;
    }

    return JSON.stringify(parameters);
  }
}

export default HttpClient;
